let gaTrackingId,
    fbPixelId;
if (window.location.hostname === 'www.zno.dp.ua') {
    gaTrackingId = 'UA-180816090-1';
    fbPixelId = '385815519433239';
}

export const GA_TRACKING_ID = gaTrackingId;
export const FB_PIXEL_ID = fbPixelId;